import { useState } from 'react'
import {
  ContactFormValues,
  ReferralContactUpdateForm,
} from './referralContactUpdateForm'
import {
  ResourceInfoFormValues,
  ResourceInfoSection,
} from './resourceInfoSection'
import { ReferralVerificationData } from './types'

export type ContactResourceFormValues = ContactFormValues & {
  resource?: ResourceInfoFormValues
}

export interface ReferralContactResourceUpdateFormProps {
  referral: ReferralVerificationData
  trackingRef: string
  onSubmit: (values: ContactResourceFormValues) => void
}

export const ReferralContactResourceUpdateForm = ({
  referral,
  trackingRef,
  onSubmit,
}: ReferralContactResourceUpdateFormProps): JSX.Element => {
  const [resourceValues, setResourceValues] = useState<ResourceInfoFormValues>()

  const handleSubmit = (contactValues: ContactFormValues): void => {
    onSubmit({ ...contactValues, resource: resourceValues })
  }

  return (
    <ReferralContactUpdateForm
      referral={referral}
      trackingRef={trackingRef}
      onSubmit={handleSubmit}
    >
      {referral.center ? (
        <ResourceInfoSection
          center={referral.center}
          onChange={setResourceValues}
        />
      ) : undefined}
    </ReferralContactUpdateForm>
  )
}
